module.exports = __webpack_public_path__ + "img/plus.eb769967.png";